import { Provider } from '@angular/core'
import { PlayingGameService } from 'game-services'
import { GamePlayConfig } from 'shared-services'
import { gamePlayConfigToken } from 'shared-components'

export const playingGameServiceProvider: Provider = {
  provide: PlayingGameService,
  useFactory: (gamePlayConfig: GamePlayConfig): PlayingGameService => {
    return new PlayingGameService(gamePlayConfig)
  },
  deps: [gamePlayConfigToken],
}
